import { apiClient, bearer, unwrap } from './client';
import type { KbAnswerOut, KbUsageRollupOut, KbUsageTotalsOut } from './types';

/** Ask a free-form GST/HST question against the knowledge base. Read-only:
 *  returns a CRA-cited answer (or a grounded=false abstention) plus the
 *  actual + estimated cost of the call. */
export async function askKb(
  question: string,
  idToken: string,
  k?: number,
): Promise<KbAnswerOut> {
  return unwrap(
    await apiClient.POST('/api/kb/ask', {
      body: { question, k: k ?? 8 },
      headers: bearer(idToken),
    }),
  );
}

/** Cumulative KB call count + spend — the in-app cost widget (§7.4). */
export async function kbUsageTotals(idToken: string): Promise<KbUsageTotalsOut> {
  return unwrap(
    await apiClient.GET('/api/kb/usage/totals', { headers: bearer(idToken) }),
  );
}

/** KB spend broken down by surface (ask / explain / suggest) + grand total —
 *  the cost-rollup widget (§7.4). */
export async function kbUsageRollup(idToken: string): Promise<KbUsageRollupOut> {
  return unwrap(
    await apiClient.GET('/api/kb/usage/rollup', { headers: bearer(idToken) }),
  );
}
